// Shared per-tag historian apply loop (BETA-53, docs/battex/beta/
// PROPOSAL-13-tag-setup.md §6.4). Resolves a tag's full path to its id and
// PUTs the historian policy — the same request the Tags panel's per-tag
// toggle sends. Three surfaces call this exact function so they can never
// disagree about what "enable history" means:
//   - the "Agregar dispositivo" wizard (EdgeConnectorsModal's historian step)
//   - the agent's `apply_device_template` mutation (mutationDispatcher.js)
//   - the agent's `set_tags_historian` mutation (mutationDispatcher.js)
//
// Never throws: a tag that cannot be resolved or is rejected by the backend
// is reported in its own result entry, not raised, so one bad path never
// loses the rest of a folder/device.
import { resolveTagPathToId, setTagHistorianPolicy } from "../../../api";

export async function applyHistorianToTagPaths(tagPaths, policy) {
  const results = [];
  for (const rawPath of tagPaths) {
    const path = String(rawPath || "").trim();
    if (!path) continue;
    let tagID = null;
    try {
      tagID = await resolveTagPathToId(path);
    } catch {}
    if (!tagID) {
      results.push({ path, ok: false, error: "tag not found" });
      continue;
    }
    try {
      await setTagHistorianPolicy(tagID, policy);
      results.push({ path, ok: true });
    } catch (err) {
      results.push({ path, ok: false, error: String(err?.message || err) });
    }
  }
  return results;
}

// Generous, non-aggressive default: mode 0 (on-change) needs no interval at
// all, which is the right default for slow, easily-overloaded hardware like
// a Solis inverter. Never invent a fast interval as a default.
export const DEFAULT_HISTORIAN_MODE = 0;
